import styled from '@emotion/styled';
import { Popover } from '@mui/material';
import { DotsThreeVertical } from '@phosphor-icons/react';
import { IconButton } from 'components';
import { useState } from 'react';
import { colors } from 'styles/theme/colors';

interface ActionsPopupProps {
  children?: React.ReactNode;
}

export const ActionsPopup = ({ children }: ActionsPopupProps) => {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const isActionsOpen = Boolean(anchorEl);

  const handleKeyPress = (event: React.KeyboardEvent<HTMLElement>) => {
    const isEnter = event.key === 'Enter';
    const isEscape = event.key === 'Escape';
    if ((isEnter || isEscape) && isActionsOpen) {
      handleClose();
    }
  };
  const id = isActionsOpen ? 'table-actions-popover' : undefined;
  return (
    <>
      <IconButton
        sx={{
          ...(isActionsOpen ? { background: colors.mintGreen[300] } : {}),
        }}
        onClick={handleClick}
        aria-describedby={id}
        size="lg"
      >
        <DotsThreeVertical />
      </IconButton>
      <StyledPopover
        id={id}
        open={isActionsOpen}
        anchorEl={anchorEl}
        onClose={handleClose}
        onKeyDown={handleKeyPress}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        disableRestoreFocus
      >
        {children}
      </StyledPopover>
    </>
  );
};

const StyledPopover = styled(Popover)`
  .MuiPopover-paper {
    background-color: ${p => p.theme?.palette?.bg?.primary};
    max-width: 1000px;
    max-height: calc(100vh - 200px);
    border-radius: 8px;
    border: 0.5px solid ${p => p.theme?.palette?.border?.primarySubtle};
    overflow: auto;
    padding: 8px;
    margin-top: 5px;
    box-shadow:
      0px 12px 16px -4px rgba(16, 24, 40, 0.08),
      0px 4px 6px -2px rgba(16, 24, 40, 0.03);
  }
`;
